import { render, staticRenderFns } from "./AdminSpecialistTravelArchive.vue?vue&type=template&id=09536203"
import script from "./AdminSpecialistTravelArchive.vue?vue&type=script&lang=js"
export * from "./AdminSpecialistTravelArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports